import React from 'react';
import CheckmarkCompletedIcon from 'src/components/common/icons/CheckmarkCompleted';
import CheckmarkNotStartedIcon from 'src/components/common/icons/CheckmarkNotStarted';
import CheckmarkStartedIcon from 'src/components/common/icons/CheckmarkStarted';
import './FlowTracker.scss';

interface FlowTrackerProps {
  currentFlowStep: number;
  items: string[];
}

const FlowTracker: React.FC<FlowTrackerProps> = (props) => {
  const { currentFlowStep, items } = props;

  if (items.length === 0 || currentFlowStep < 0 || currentFlowStep >= items.length) {
    return <></>;
  }

  return (
    <div>
      {items.map((item, index) => {
        const isNotStarted = index > currentFlowStep;
        const textFontWeight = isNotStarted
          ? 'b-font-weight-light'
          : 'b-font-weight-bold';

        return (
          <div key={index} className="flow-tracker-item" data-testid="flow-tracker-item">
            {index < currentFlowStep && (
              <CheckmarkCompletedIcon data-testid="checkmark-completed-icon" />
            )}
            {index === currentFlowStep && (
              <CheckmarkStartedIcon data-testid="checkmark-started-icon" />
            )}
            {isNotStarted && (
              <CheckmarkNotStartedIcon data-testid="checkmark-not-started-icon" />
            )}
            <span
              className={`flow-tracker-text b-typography-sans-serif--body--200 ${textFontWeight}`}
            >
              {item}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default FlowTracker;
